module.exports = __webpack_public_path__ + "static/media/ilovebdj.605658fb.jpg";